export enum DemandeType {
  Recrutement = 'Recrutement',
  Renouvellement = 'Renouvellement'
}
